import { useCallback, useEffect, useRef } from 'react';

import { fetchGamblingLegalText } from './fetchGamblingLegalText';

/**
 * Fetches gambling legal modal texts by slug with an in-memory cache.
 *
 * @param {object} params
 * @param {string} params.url - Modals API base URL.
 * @param {object} params.modals_slug - Slug map (`about_us`, `privacy_policy`, `terms`).
 * @returns {{ getText: (type: 'about'|'privacy'|'terms') => Promise<{ title: string, content: string }> }}
 */
export const useWebsiteDataService = ({ url, modals_slug }) => {
    const textsRef = useRef({});

    useEffect(() => {
        textsRef.current = {};
    }, [url, modals_slug]);

    const getText = useCallback(
        (type) => fetchGamblingLegalText(url, modals_slug, type, textsRef.current),
        [url, modals_slug]
    );

    return { getText };
};
